"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var noop = exports.noop = function noop() {};
exports.default = noop;



//////////////////
// WEBPACK FOOTER
// ./~/rmwc/Base/utils/noop.js
// module id = 20
// module chunks = 35783957827783 96961042003272 114276838955818 142807904292071